import cn from 'classnames';
import styles from "./SectionHelper.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const SectionHelper = _ref => {
  let {
    children,
    className
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: cn(styles.root, className),
    children: children
  });
};